import { MouseEvent } from 'react';

export type MouseEventHandler = (e?: MouseEvent<any>) => void;

export interface ISelectOption<T extends Record<string, unknown> = any> {
  value: string;
  label: string;
  data?: T;
}

export type OptionMap = (option: unknown) => ISelectOption;

export type ID = string | number;

export enum OkResult {
  ok = 'ok',
}
